import React from 'react';
import { Link } from 'react-router-dom'
class NotFound extends React.Component {
    render(props) {
        return(
            <div className="">
                <div className="d-sm-none d-md-block col-md-2"></div>
                <div className="col-sm-12 col-md-8">
                    <div className="oam-password-detail-tips">
                        <div className="row">
                            <div className="row row-equal">
                                <h1> Requested Page Not Found. Please click <Link className="btn btn-primary" href="/" to={window.env.appcontext + "/"}>here</Link> for go back to home page </h1>
                            </div>
                    
                        
                        </div>
                   </div>

                </div>
                <div className="d-sm-none d-md-block col-md-2"></div>
            </div>
        );
    }
}

export default NotFound;